module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACCSURBVDiN3ZPBDYMwFEOfEYN0A+gGrMIInYBRygawASvABLCJe2g4cACRlF54l0hfiWPZ+nAFtgfHMwAoCDjlY0nKfnX/V4EWqIElVWCR1AJPoE8RWKmA8vDGTk2z7fdRj9yjxjycL6CIfDuxZsA3h0dI/AyjpHEzsd1ELFIX6XafD1Q5sMwkvAzUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pending.png
// module id = cOxb
// module chunks = 1